import { FC } from "react";

import { ImageCollection } from "common/config/media.config";

import "./UnAuthorized.scss";

const UnAuthorized: FC = () => {
  return (
    <div className="unauthorized">
      <img src={ImageCollection.XM_LOGO_SMALL} />
      <div className="info-container">
        <span>Sorry! You do not have access to this application.</span>
      </div>
    </div>
  );
};

export default UnAuthorized;
